import React from 'react';
import { Group, Text, TextInput } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { CountBadge } from 'src/UI/page-nav/sidebar/CountBadge';

interface PageHeaderProps {
  title: string;
  badgeCount?: number;
  showSearch?: boolean;
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  actions?: React.ReactNode;
  children?: React.ReactNode;
}

export function PageHeader({
  title,
  badgeCount,
  showSearch = false,
  searchValue = '',
  onSearchChange,
  actions,
}: PageHeaderProps) {
  return (
    <Group justify="space-between">
      <Group gap="sm" wrap="nowrap">
        <Text size="displayMd" fw={FONT_WEIGHTS.medium} c="gray.10">
          {title}
        </Text>
        {badgeCount !== undefined && badgeCount > 0 && (
          <CountBadge count={badgeCount} size="large" />
        )}
      </Group>

      <Group gap="sm" ml="auto" miw={0}>
        {showSearch && (
          <TextInput
            placeholder="Search"
            leftSection={<IconSearch size={16} />}
            value={searchValue}
            onChange={e => onSearchChange?.(e.target.value)}
            variant="compact"
            styles={{
              input: {
                height: 40,
              },
            }}
            w={320}
            style={{ minWidth: 0 }}
          />
        )}
        {actions}
      </Group>
    </Group>
  );
}
